import { render } from "./popper-help.vue?vue&type=template&id=2912fc82"
import script from "./popper-help.vue?vue&type=script&lang=js"
export * from "./popper-help.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__